import { IGame } from "types/IGame";
import { ASSET_PREFIX } from "utils/constants";

export const Game: { [key: string]: IGame } = {
  WeeklyDraw: {
    id: 'DAYMADEDRAW',
    name: 'Weekly Draws',
    tabName: 'weekly-draw',
    thumbnail: `${ASSET_PREFIX}/images/game-selector/weekly-draw-thumbnail.svg`,
    selectedIcon: `${ASSET_PREFIX}/images/game-selector/weekly-draw-selected.png`,
  },
  DailyPoundRaffle: {
    id: 'POUND_RAFFLE',
    name: 'Pound Raffle',
    tabName: 'pound-raffle',
    thumbnail: `${ASSET_PREFIX}/images/game-selector/pound-raffle-thumbnail.svg`,
    selectedIcon: `${ASSET_PREFIX}/images/game-selector/pound-raffle-selected.png`,
  },
  TokenTown: {
    id: 'TOKEN_TOWN',
    name: 'Token Town',
    tabName: 'token-town',
    thumbnail: `${ASSET_PREFIX}/images/game-selector/token-town-thumbnail.svg`,
    selectedIcon: `${ASSET_PREFIX}/images/game-selector/token-town-selected.png`,
  },
  DailyChallenger: {
    id: 'FREE_DAILY_DRAW',
    name: 'Free Daily Draw',
    tabName: 'daily-challenger',
    thumbnail: `${ASSET_PREFIX}/images/game-selector/daily-challenger-thumbnail.svg`,
    selectedIcon: `${ASSET_PREFIX}/images/game-selector/daily-challenger-selected.png`,
  },
  IcelandRaffle: {
    id: 'ICELAND_RAFFLE',
    name: 'Iceland Raffle',
    tabName: 'iceland-raffle',
    thumbnail: `${ASSET_PREFIX}/images/game-selector/iceland-raffle-thumbnail.svg`,
    selectedIcon: `${ASSET_PREFIX}/images/game-selector/iceland-raffle-selected.png`,
  },
  OtherRaffles: {
    id: 'OTHER_RAFFLES',
    name: 'Other Raffles',
    tabName: 'other-raffles',
    thumbnail: `${ASSET_PREFIX}/images/game-selector/other-raffles-thumbnail.svg`,
    selectedIcon: `${ASSET_PREFIX}/images/game-selector/other-raffles-selected.png`,
  },
};
